export default __webpack_public_path__ + "static/Fig 14 - Sections-9fc646121112036d84238a1359c7e7c1.pdf";